import { MapDrawerEntityForPoiMetadataByType } from 'features/mapping/mapping.types';
import { useMapDrawerEntityForPoiState } from 'state/useMapDrawerEntityForPoiState';
import { PrivateLandOwnershipContent } from '../layers/PrivateLandOwnershipLayer/PrivateLandOwnershipContent';
import { ExternalFeatureDrawerContent } from '../layers/ExternalFeatureLayer/ExternalFeatureDrawerContent';

type ContentComponents = {
  [K in keyof MapDrawerEntityForPoiMetadataByType]: (
    props: MapDrawerEntityForPoiMetadataByType[K],
  ) => JSX.Element;
};

const MAP_DRAWER_ENTITY_CONTENT_COMPONENTS: ContentComponents = {
  privateLandOwnership: PrivateLandOwnershipContent,
};

export const MapDrawerEntityContentForPoi = (): JSX.Element | null => {
  const { mapDrawerEntityForPoi } = useMapDrawerEntityForPoiState();

  if (!mapDrawerEntityForPoi) {
    return null;
  }

  if ('metadata' in mapDrawerEntityForPoi) {
    const { type, metadata } = mapDrawerEntityForPoi;

    const Content = MAP_DRAWER_ENTITY_CONTENT_COMPONENTS[type];
    return <Content {...metadata} key={type} />;
  }

  const { type, id, displayName } = mapDrawerEntityForPoi;
  return (
    <ExternalFeatureDrawerContent
      key={type}
      sourceId={type}
      featureId={id}
      displayName={displayName}
    />
  );
};
